import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from "../../../../services/task.service";
import {DatePipe} from "@angular/common";
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-status-condition-create',
  templateUrl: './status-condition-create.component.html',
  styleUrls: ['../parts.css', './status-condition-create.component.css']
})
export class StatusConditionCreateComponent implements OnInit {

  boards = [];
  boardId;

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  conditionColumns = [];

  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字

  statusColumnDisplayText = '状态'; // 状态列显示文字
  statusPopVisible = false; // 状态列pop显示
  statusColumnList = []; // 状态列可选值

  columnValueDisplayText = '某值'; // 状态列的值的默认文字
  columnValuePopVisible = false; // 状态列值pop显示
  columnValueList = []; // 状态列值可选择值

  conditionDisplayText = '条件';
  conditionPopVisible = false;
  conditions = [];
  filterConditions = [];

  targetGroupVisible = false;
  targetGroupId = null;
  targetGroupDisplayText = '分组';

  targetBoardVisible = false;
  targetBoardId;
  targetBoardDisplayText = '面板';
  targetBoardData = {};
  targetGroups = [];
  targetColumns = [];
  targetIntegrationColumns = [];
  integrationColumnTypes = ['name', 'text', 'relation-data'];

  mailPopVisible = false;
  receiverPopVisible = false;
  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID
  taskIntegrationData: any = {};

  conditionOpe1 = [
    {title: '等于', operator: 'is'},
    {title: '不等于', operator: 'is_not'}
    ];
  conditionOpe2 = [
    {title: '等于', operator: 'is'},
    {title: '不等于', operator: 'is_not'},
    {title: '包含', operator: 'includes'},
    {title: '不包含', operator: 'not_includes'}
  ];

  automation = {
    boardId: '',
    columnId: '',
    categoryId: '',
    relationId: '',
    groupId: '',
    userColumnId: '',
    email: null,
    siteMessage: null,
    sms: null,
    columnValue: {
      index: null,
      indexes: []
    },
    receiver: {
    },
    conditions: [],
    taskMapping: {},
    targetGroupId: '',
    targetBoardId: '',
    instanceDescription: ''
  }; // 存放入参数据
  @ViewChild('pulseCard') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private datePipe: DatePipe,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (const column of this.boardColumnData) {
          if (column.type === 'status') {
            this.statusColumnList.push(column);
            this.conditionColumns.push(column);
          } else if (column.type === 'taskProgress') {
            this.statusColumnList.push(column);
            this.conditionColumns.push(column);
          }
          if (column.type === 'name' || column.type === 'date' || column.type === 'text') {
            this.conditionColumns.push(column);
          }
          if (this.integrationColumnTypes.includes(column.type)) {
            this.targetIntegrationColumns.push(column);
          }
        }
      }
    }
    // 处理实例数据
    if (this.instanceData && this.instanceData.config) {
      this.taskIntegrationData = this.instanceData.config.taskMapping;
      this.groupConditionId = this.instanceData.config.groupId;
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      for (let group of this.boardGroupData) {
        if (group.id === this.groupConditionId) {
          this.groupConditionDisplayText = group.title;
          group.checked = true;
          break;
        }
      }
      for (let column of this.statusColumnList) {
        if (column.id == this.automation.columnId) {
          this.statusColumnDisplayText = column.title;
          this.columnValueList = column.labels;
          break;
        }
      }
      if (this.automation.columnValue && this.automation.columnValue.indexes) {
        this.getStatusValueText();
      }
      this.filterConditions = this.automation.conditions || [];
      this.targetBoardId = this.automation.targetBoardId;
      this.targetGroupId = this.automation.targetGroupId;
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
    this.targetBoardData = {};
    this.targetBoardData['id'] = this.targetBoardId;
    this.targetBoardData['boardData'] = {};
    this.taskService.getUserBoardData().subscribe(res => {
      if (res) {
        this.boards = res.boards || [];
        for (let board of this.boards) {
          if (this.targetBoardId == board.id) {
            this.targetBoardDisplayText = board.name;
            break;
          }
        }
        if (this.targetBoardId) {
          this.taskService.getBoardGroups(this.targetBoardId).subscribe((res: any) => {
            if (res) {
              this.targetGroups = res || [];
              this.targetBoardData['boardData']['groups'] = this.targetGroups;
              for (let group of this.targetGroups) {
                if (this.targetGroupId == group.id) {
                  this.targetGroupDisplayText = group.title;
                  break;
                }
              }
            }
          });
          this.handleTargetBoardColumn();
        }
      }
    });
  }

  // 分组变更
  groupConditionChange(item) {
    item.checked = !item.checked;
    this.getGroupIds();
    this.automation.groupId = this.groupConditionId;
    this.packageData();
  }

  getGroupIds() {
    const idSet = new Set();
    const groupNames = [];
    for (const group of this.boardGroupData) {
      if (group.checked) {
        idSet.add(group.id);
        groupNames.push(group.title);
      }
    }
    const ids = Array.from(idSet);
    this.groupConditionId = ids.join(',');
    this.groupConditionDisplayText = groupNames.join(',');
    this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
      `${this.groupConditionDisplayText.slice(0,12)}...` : this.groupConditionDisplayText;
  }

  statusSelectChange(item) {
    this.statusColumnDisplayText = item.title;
    this.automation.columnId = item.id;
    this.statusPopVisible = false;
    this.columnValueList = item.labels;
    this.automation.columnValue.indexes = [];
    this.columnValueDisplayText = '某值';
  }

  columnValueSelectChange(item) {
    let i = this.automation.columnValue.indexes.findIndex((index) => index == item.index);
    if (i > -1) {
      this.automation.columnValue.indexes.splice(i, 1);
    } else {
      this.automation.columnValue.indexes.push(item.index);
    }
    this.getStatusValueText();
    this.packageData();
  }

  getStatusValueText() {
    let texts = [];
    for (let item of this.columnValueList) {
      if (this.automation.columnValue.indexes.includes(item.index)) {
        texts.push(item.label);
      }
    }
    this.columnValueDisplayText = texts.join('或');
  }

  conditionPopChange() {
    if (!this.conditionPopVisible) {
      this.automation.conditions = this.filterConditions;
      this.packageData();
    }
  }

  // 添加筛选条件
  addFilterCondition() {
    this.filterConditions.push({
      title: null,
      field: null,
      type: null,
      value: null,
      valueText: null,
      operators: [],
      operator: {
        title: null,
        operator: null
      }
    });
  }

  // 删除筛选条件
  deleteFilterCondition(index: number) {
    this.filterConditions.splice(index, 1);
  }

  // 处理主题选项更改事件
  handleFilterConditionSelectChange(column, condition) {
    condition.title = column.title;
    condition.field = column.id;
    condition.type = column.type;
    if (column.type == 'name' || column.type == 'text') {
      condition['operators'] = this.conditionOpe2;
    } else if (column.type == 'status') {
      condition['operators'] = this.conditionOpe1;
      condition['valueConfig'] = column.labels;
    } else if (column.type == 'date') {
      condition['operators'] = this.conditionOpe1;
    }
    condition['operator']['title'] = condition['operators'][0]['title'];
    condition['operator']['operator'] = condition['operators'][0]['operator'];
    condition['visible'] = false;
  }

  // 处理操作符选项变更
  handleConditionOperatorChange(condition, operator) {
    condition['operator']['title'] = operator['title'];
    condition['operator']['operator'] = operator['operator'];
    condition['operatorVisible'] = false;
  }

  // 日期变更
  dateChange(condition) {
    if (condition['value']) {
      condition['value'] = this.datePipe.transform(condition['value'], 'yyyy-MM-dd');
    }
  }

  // 处理筛选值变更
  handleConditionValueChange(condition, option) {
    condition['value'] = option['index'];
    condition['valueText'] = option['label'];
    condition['valueVisible'] = false;
  }

  handleTargetBoardChange(board) {
    this.targetBoardData = board;
    this.targetBoardData['boardData'] = {};
    this.targetBoardId = board.id;
    this.targetBoardDisplayText = board.name;
    this.automation.targetBoardId = board.id;
    this.automation.targetGroupId = '';
    this.targetGroupId = '';
    this.targetGroupDisplayText = '分组';
    this.targetBoardVisible = false;
    this.taskService.getBoardGroups(this.targetBoardId).subscribe((res: any) => {
      if (res) {
        this.targetGroups = res || [];
      } else {
        this.message.info('未查询到该面板下的分组信息，请选择其他面板');
      }
      this.targetBoardData['boardData']['groups'] = this.targetGroups;
    });
    this.handleTargetBoardColumn();
  }

  handleTargetBoardColumn() {
    this.taskService.getBoardColumn(this.targetBoardId).subscribe((res: any) => {
      if (res) {
        this.targetColumns = res || [];
      }
      this.targetBoardData['boardData']['columns'] = this.targetColumns;
    });
  }

  handleTargetGroupChange(group) {
    this.targetGroupId = group.id;
    this.targetGroupDisplayText = group.title;
    this.automation.targetGroupId = group.id;
    this.packageData();
  }

  openTaskDialog() {
    this.isVisible = true;
  }

  handleOk() {
    this.pulseIntegration.onSubmit();
    this.isVisible = false;
  }

  // 获取任务创建数据
  getTaskIntegrationData(event) {
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.taskIntegrationData = this.automation.taskMapping;
    this.packageData();
  }

  packageData() {
    this.automation.instanceDescription = '在 ' + this.groupConditionDisplayText + ' 中，' + '当 ' + this.statusColumnDisplayText
      + ' 变更为 ' + this.columnValueDisplayText + ' 且满足 条件 时，' +  '在 ' + this.targetBoardDisplayText + ' 的 ' +
      this.targetGroupDisplayText + ' 创建一条 任务';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.automation.groupId &&
      this.automation.columnId &&
      this.automation.columnValue.indexes !== null && this.automation.columnValue.indexes.length > 0 &&
      this.automation.targetBoardId && this.automation.targetGroupId && this.automation.taskMapping &&
      this.automation.conditions && this.automation.conditions.length > 0;
  }
}
